// extracted by mini-css-extract-plugin
export default {"Term":"Term_Term__g0XT0","TermContent":"Term_TermContent__OlmxX","Input":"Term_Input__3sT8T"};